module.exports = __webpack_public_path__ + "img/chuan3.f78bf872.png";